import { render, staticRenderFns } from "./epb-input-label.component.vue?vue&type=template&id=37e0ea0f&scoped=true"
import script from "./epb-input-label.component.vue?vue&type=script&lang=ts"
export * from "./epb-input-label.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-input-label.component.vue?vue&type=style&index=0&id=37e0ea0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0ea0f",
  null
  
)

export default component.exports